<script lang="ts">
  import { navigate } from "svelte-navigator";

  navigate("/");
</script>
